import { AppState } from '../store';

export function getUser(state: AppState) {
  return state.auth;
}
